import RenderImg from '@/pages/opinion/components/RenderImg';
import ChannelLabel from '@op/components/ChannelLabel';
import './index.scss';
import React from 'react';
import useLanguage from '@op/hooks/useLanguage';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import { SORT_STREAMING_OPTIONS, SORT_VIDEO_OPTIONS } from '../../constant';
import { DBO_TM, DBO_V } from '@op/utils/format';
import { transLanguage } from '@op/utils';
import { useFeedsSteamingData, useFeedsVideoData } from '@op/hooks/data/video';
import { LanguageType } from '@op/types/common';
import { goToFeedsReviewsDetail } from '@op/utils/url';
import { useHistory } from 'umi';


function CommonCardInfo({
  list,
  bottomElement,
  channel,
  userName,
  videoDefaultImage,
  videoDuration,
  videoImage,
  videoContent,
  data,
  language,
  gameInfo,
  isLiveStream,
  filter
}: {
  list: { text: string; value: string | number }[];
  bottomElement: JSX.Element;
  data: any;
  channel: any;
  userName: string;
  videoDefaultImage: string;
  videoDuration: string;
  videoImage: string;
  videoContent: string | JSX.Element;
  language: LanguageType;
  gameInfo: any;
  isLiveStream?: boolean;
  filter: any;
}) {
  const { formatMessage } = useLanguage();
  const openVideoPage = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    comment_url: string | URL | undefined,
  ) => {
    if (!comment_url) return;
    window.open(comment_url);
    event.stopPropagation();
  };
  const history = useHistory();

  return (
    <div className="dbo-feeds-info-card">
      <div className="dbo-feeds-info-card-content"
        onClick={(event) => {
          if (!isLiveStream) {
            goToFeedsReviewsDetail(
              history,
              data,
              gameInfo?.edition_unified_id
                ? { language, gameid: gameInfo?.edition_unified_id }
                : { language },
            );
            event.stopPropagation();
          } else {
            openVideoPage(event, data?.content_url || data?.live_url);
            // history.push(
            //   `/opinion/Realtime/RealtimeStreaming/Details/${data.live_id
            //   }?start_time=${decodeURIComponent(
            //     filter.start_time,
            //   )}&end_time=${decodeURIComponent(filter.end_time)}`,
            // );
            event.preventDefault();
          }
        }}>
        <div className="dbo-feeds-info-card-cover">
          <RenderImg
            className="dbo-feeds-info-card-cover-img dbo-videobox-cover"
            defaultImage={videoDefaultImage}
            coverImage={videoImage}
          />
          {videoDuration && (
            <div className="dbo-feeds-info-card-playnum">
              <span>{videoDuration}</span>
            </div>
          )}
        </div>
        <div className="dbo-feeds-info-card-info">
          <div className="dbo-feeds-info-card-hd">
            <ChannelLabel
              className="dbo-feeds-info-card-icon"
              channel_name={channel}
              showText={false}
            />
            <div className="dbo-feeds-info-card-title">{userName}</div>
            <Bubble
              dark
              placement="top"
              content={formatMessage({ id: 'Go to original post' })}
            >
              <div
                className="dbo-feeds-info-card-share"
                onClick={(event) => {
                  openVideoPage(event, data?.content_url || data?.live_url);
                  event.preventDefault();
                }}
              >
                <SvgIcon type="other-share-icon" className="dbo-feeds-btn-icon" />
              </div>
            </Bubble>
          </div>
          <div className="dbo-feeds-info-card-desc">
            <Bubble
              closeOnScroll
              dark
              content={videoContent}
              overlayClassName="dbo-figure-card-bubble"
            >{videoContent}
            </Bubble>
          </div>
          <div className="dbo-feeds-info-card-subinfo">{bottomElement}</div>
          <div className="dbo-feeds-info-card-numbox-list">
            {list.map((item) => {
              return (
                <div key={item.text} className="dbo-feeds-info-card-numbox">
                  <div className="dbo-feeds-info-card-num">{item.value}</div>
                  <div className="dbo-feeds-info-card-numtitle">
                    {formatMessage({ id: item.text })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

type CardInfoType = {
  data: any;
  lang?: LanguageType;
  gameInfo: any;
  filter?: any;
};

export function VideoCardInfo({ data, lang = 'origin', gameInfo }: CardInfoType) {
  const { language, comment_time } = data || {};
  const { channel_name, reviewer } = data || {};
  const videoInfo = useFeedsVideoData({ data, language: lang });

  return (
    <CommonCardInfo
      list={SORT_VIDEO_OPTIONS.map((item) => {
        const key = item.valueKey || item.value;
        const value = Number(data?.[key]) || 0;
        return {
          text: item.text,
          value: DBO_V.reviews(value <= 0 ? 0 : value, 2, '-'),
        };
      })}
      channel={channel_name}
      userName={reviewer}
      data={data}
      {...videoInfo}
      bottomElement={
        <>
          <span className="dbo-feeds-info-card-country">
            {transLanguage(language)}
          </span>
          <span className="dbo-feeds-info-card-time">
            {DBO_TM.sFormat(comment_time, 'YYYY-MM-DD HH:mm')}
          </span>
        </>
      }
      language={lang}
      gameInfo={gameInfo}
    />
  );
}

export function StreamingCardInfo({ data, lang = 'origin', gameInfo, filter }: CardInfoType) {
  const { formatMessage } = useLanguage();
  const { live_time, live_anchors, source } = data || {};
  const videoInfo = useFeedsSteamingData({ data, language: lang });
  return (
    <CommonCardInfo
      list={SORT_STREAMING_OPTIONS.map((item) => {
        const key = item.value;
        const value = Number(data?.[key]) || 0;
        return {
          text: item.text,
          value: DBO_V.reviews(value <= 0 ? 0 : value, 2, '-'),
        };
      })}
      data={data}
      bottomElement={
        <>
          <span className="dbo-feeds-info-card-time">
            {formatMessage('Live Stream Time')}:{' '}
            {DBO_TM.sFormat(live_time, 'YYYY-MM-DD HH:mm')}
          </span>
        </>
      }
      channel={source}
      userName={live_anchors}
      language={lang}
      gameInfo={gameInfo}
      isLiveStream
      filter={filter}
      {...videoInfo}
    />
  );
}
